export const queryOptions = {
  // The metrics populating the Partner Program page is fairly stable. No
  // need to refetch it frequently.
  staleTime: 600000,
};
